import React from 'react';
import ReactApexChart from 'react-apexcharts';
import LoadingSkeleton from "components/shared/LoadingSkeleton/Index";
import { formatText } from "helpers/common";

const ThirdPartyConnectionStats = ({ isLoading, data }) => {
    const { series, categories } = React.useMemo(() => {
        let output = {
            categories: [],
            series: [],
        };

        if (!data?.length) return output;

        const values = data.map(item => item.count);
        const labels = data.map(item => formatText(item.connection_type));

        output.categories = labels;
        output.series = [{
            name: 'Connections',
            data: values
        }];

        return output;
    }, [data]);

    const chartOptions = {
        chart: {
            type: 'bar',
            toolbar: { show: false }
        },
        xaxis: {
            categories,
            labels: {
                style: {
                    fontSize: '12px'
                }
            }
        },
        yaxis: {
            labels: {
              formatter: function (val) {
                return Number.isInteger(val) ? val : '';
              },
              style: {
                fontSize: '12px'
              }
            },
            tickAmount: 5,
            forceNiceScale: true
        },
        colors: ['#0059b3'],
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '50%',
                borderRadius: 4
            }
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false
        }
    };

    return (
        <div className='border bg-white p-3 rounded-3'>
            <h4 className='mb-2'>Third Party Connections</h4>
            <div className="mt-4">
                {isLoading ? (
                    <div className="d-flex align-items-center flex-column mt-2">
                        <LoadingSkeleton
                            innerStyle={{
                                height: "200px",
                                width: "100%",
                                borderRadius: "4px"
                            }}
                        />
                        <LoadingSkeleton style={{ width: "75%" }} />
                    </div>
                ) : !data?.length ? (
                    <p>No data found</p>
                ) : (
                    <ReactApexChart
                        options={chartOptions}
                        series={series}
                        type="bar"
                        height={300}
                    />
                )}
            </div>
        </div>
    );
};

export default ThirdPartyConnectionStats;
